// @flow
import React, { useContext, Fragment } from 'react';
import classnames from 'classnames';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';

import {
  ActionButtonsGroup,
  type ActionButtonsGroupItemProps,
} from 'Components/frameworks/action-buttons-group/ActionButtonsGroup.jsx';
import {
  MediaThumbnail,
  type MediaThumbnailProps,
} from 'Components/frameworks/media-thumbnail/MediaThumbnail.jsx';
import { YoukuThumbnail } from 'Components/frameworks/image/YoukuThumbnail.jsx';

const YOUKU_SRC = 'vthumb.ykimg.com';

export type MultimediaLauncherProps = {
  className?: string,
  hasLazyLoading?: boolean,
  isOverlay?: boolean,
  items: Array<ActionButtonsGroupItemProps>,
  thumbnails: Array<MediaThumbnailProps>,
};

function MultimediaLauncherThumbnail(props) {
  return props.src ? (
    <MediaThumbnail {...props} hasLazyLoading={props.hasLazyLoading}>
      {props.src.includes(YOUKU_SRC) ? (
        <YoukuThumbnail imageUrl={props.src} ratioKey={props.ratio} />
      ) : null}
    </MediaThumbnail>
  ) : null;
}

export function MultimediaLauncher(props: MultimediaLauncherProps) {
  const { className, hasLazyLoading, isOverlay, items, thumbnails = [] } = props;

  const thumbs = thumbnails.filter(t => t.src);

  const { isTablet } = useContext(ResponsiveContext);

  return (
    <div className={classnames(className, 'overflow-hidden')}>
      {!isOverlay && (
        <Fragment>
          {isTablet ? (
            <div className="fadeIn flex -m-px border-b-1 border-transparent">
              <div className="p-px w-1/2">
                <MultimediaLauncherThumbnail {...thumbs[0]} hasLazyLoading={hasLazyLoading} />
              </div>
              <div className="flex flex-wrap w-1/2">
                <div className="w-1/2 p-px">
                  <MultimediaLauncherThumbnail {...thumbs[1]} hasLazyLoading={hasLazyLoading} />
                </div>
                <div className="w-1/2 p-px">
                  <MultimediaLauncherThumbnail {...thumbs[2]} hasLazyLoading={hasLazyLoading} />
                </div>
                <div className="w-1/2 p-px">
                  <MultimediaLauncherThumbnail {...thumbs[3]} hasLazyLoading={hasLazyLoading} />
                </div>
                <div className="w-1/2 p-px">
                  <MultimediaLauncherThumbnail {...thumbs[4]} hasLazyLoading={hasLazyLoading} />
                </div>
              </div>
            </div>
          ) : (
            <div className="fadeIn border-b-2 border-transparent">
              <MultimediaLauncherThumbnail {...thumbs[0]} hasLazyLoading={hasLazyLoading} />
            </div>
          )}
        </Fragment>
      )}
      <ActionButtonsGroup
        className="fadeIn"
        items={items}
        theme={isOverlay ? 'overlay' : 'default'}
        minWidth={isOverlay ? '6.25rem' : '8.4375rem'}
      />
    </div>
  );
}
